import ComposeSmartPillStore from '../store/schema/ComposeSmartPillStore';

export default function getInitialStore(): ComposeSmartPillStore {
    return {
        viewState: {
            barVisible: false,
        },
        allAddedPills: [],
    };
}
